// @flow
export { default } from './PartnerTags';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerTags/index.js